<script setup>
import {computed, reactive, ref} from "vue";
import multiselect from "vue-multiselect";
import PrimaryButton from "../../../../frontend/src/components/ui/PrimaryButton.vue";
import useForm from "../../../../frontend/src/composables/useForm";
import clientsService from "@/services/clients.service";

const emit = defineEmits(['saved']);

const form = reactive({
    name: "",
    is_not_company: 0,
    ignore_duplicates: 0,
    hidden: 0,
    merged_to_id: 0,
});

const {populateForm, resetForm} = useForm(form);
const id = ref(null);
const showModal = ref(false);
const loading = ref(false);
const mergedTo = ref(null);
const clientsList = ref([]);

const canSave = computed(() => !!form.name.length);

async function getData() {
    const {data: {merged_to, ...data}} = await clientsService.getEdit(id.value);
    mergedTo.value = merged_to;

    if (mergedTo.value) {
        clientsList.value = [mergedTo.value];
    }

    populateForm(data);
}

async function save() {
    loading.value = true;

    if (mergedTo.value) {
        form.merged_to_id = mergedTo.value.id;
    } else {
        form.merged_to_id = null;
    }

    await clientsService.save(id.value, form);

    showModal.value = false;
    loading.value = false;

    emit('saved');
}

async function updateClientsList(query) {
    if (query) {
        const {data} = await clientsService.getListWithRelations(query);
        clientsList.value = data.filter(item => item.id !== id.value);
    } else if (mergedTo.value) {
        clientsList.value = [mergedTo.value];
    }
}

function open(clientId = 0) {
    resetForm();
    mergedTo.value = null;

    if (clientId) {
        id.value = clientId;
        getData();
    } else {
        id.value = 0;
    }

    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" :title="`${id ? 'Edit' : 'Add'} Client`" modal-class="modal-w-md">
        <form class="form">

            <div v-if="!id" class="form__item">
                <h5 class="heading5 heading5--secondary">Name</h5>
                <input type="text" class="form-control--mid form-control" v-model="form.name">
            </div>

            <div class="form__item input-checkbox">
                <input id="is_not_company" type="checkbox" v-model="form.is_not_company">
                <label for="is_not_company">Is Not Company</label>
            </div>

            <div class="form__item input-checkbox">
                <input id="hidden" type="checkbox" v-model="form.hidden">
                <label for="hidden">Hidden</label>
            </div>

            <div class="form__item input-checkbox">
                <input id="ignore_duplicates" type="checkbox" v-model="form.ignore_duplicates">
                <label for="ignore_duplicates">Ignore Duplicates</label>
            </div>

            <div class="form__item">
                <h5 class="heading5 heading5--secondary">Merged To</h5>

                <multiselect
                    v-model="mergedTo"
                    placeholder="Select Client"
                    :options="clientsList"
                    select-label=""
                    deselect-label=""
                    label="name"
                    track-by="name"
                    class="multiselect-mid pl-2"
                    @search-change="updateClientsList"
                >
                </multiselect>
            </div>

        </form>

        <template #modal-footer>
            <PrimaryButton
                caption="Save"
                loading-caption="Saving..."
                :disabled="!canSave"
                :loading="loading"
                @click="save"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
